export const formatCLP = (value, includeSymbol = true) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(num) || num === null || num === undefined) {
    return includeSymbol ? '$0' : '0';
  }
  
  const rounded = Math.round(num);
  const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  return includeSymbol ? `$${formatted}` : formatted;
};

export const formatCLPInput = (value) => {
  const numbers = value.replace(/[^\d]/g, '');
  if (!numbers) return '';
  
  const num = parseInt(numbers, 10);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const parseCLP = (formattedValue) => {
  if (!formattedValue) return 0;
  const cleaned = formattedValue.toString().replace(/[$.]/g, '');
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};